import createBaseService from "@/api/base-service.ts";
import type { Region } from "../../types/region";

const regionService = {
	...createBaseService<Region>("/regions"),
};

export default regionService;
